<script>
import * as m from '@app/paraglide/messages.js';
    import { preventDefault } from 'svelte/legacy';

import { SvelteToast } from '@zerodevx/svelte-toast';
import { toast } from '@zerodevx/svelte-toast';
const ipcRenderer = window.ipcRenderer;
let machineId = $state(""), activationCode = $state(""), errorMsg = $state(""), loading = $state(false);
const supportEmail = "support@closedcaptioncreator.com";

async function getMachineId(){
    try {
        machineId = await ipcRenderer.invoke("getMachineId");
    } catch(err){
        console.log(err, err.message);
    }
}

async function activate(){
    loading = true;
    console.log("Activating with code: ", activationCode);
    try {
        let licenseInfo = await ipcRenderer.invoke("licenseCheck", activationCode);
        if (licenseInfo.active){
            toast.push(m.login_offline_activation_success_toast(), {classes: ['toast-`success`']});
            localStorage.setItem("cc-offline-license", activationCode);
            window.location.reload();
        } else {
            activationCode = "";
            errorMsg = m.login_offline_activation_failed_support({ email: supportEmail });

            toast.push(m.login_offline_activation_error_toast(), {classes: ['toast-`danger`']});
        } 
    } catch(err){
        errorMsg = m.login_offline_activation_failed_with_error({ message: err.message });
        toast.push(m.login_offline_activation_failed_with_error({ message: err.message }), {classes: ['toast-`danger`']});
    } finally {
        loading = false;
    }    
}

function copyMachineId(){
    navigator.clipboard.writeText(machineId);
    toast.push(m.login_offline_machine_id_copied_toast(), {classes: ['toast-`success`']});
}

async function PasteActivationCode(){
    try {
        activationCode = await navigator.clipboard.readText();
    } catch(err){
        console.log(err.message);
    }
}

getMachineId();
</script>

<SvelteToast options={{
    duration: 1500,
    position: 'top-right',
    showProgress: true,
    pauseOnHover: true,
    closeOnClick: true,
    transition: 'SlideInRight'
}}/>

<div id="LoginScreen">
    <div class="container d-flex justify-content-center align-items-center LoginPageWrapper">
        <div class="col-md-5 col-sm-8 col-11 shadow LoginFormWrapper text-white rounded border-0">
            <div class="d-flex justify-content-center align-items-center m-3 mb-4">
                <img src="./cc-logo.png" width="200px" alt={m.app_logo_alt()} class="mb-1"/>
            </div>
            
            <div class="offline-badge text-center mb-4">
                <span class="badge">{m.login_offline_mode_badge()}</span>
            </div>
            
            <form onsubmit={preventDefault(activate)}>
                <h3 class="text-center mb-4">{m.login_offline_activate_license_title()}</h3>
                
                {#if errorMsg}
                    <div class="alert alert-danger" role="alert">
                        {errorMsg}
                    </div>
                {/if}
                
                <div class="mb-3">
                    <label for="machineIdInput" class="form-label">{m.login_offline_machine_id_label()}</label>
                    <div class="input-group">
                        <input type="text" class="form-control" disabled id="machineIdInput" value={machineId}>
                        <button type="button" class="btn btn-outline-light" onclick={copyMachineId}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
                                <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
                            </svg>
                            {m.login_offline_copy_button()}
                        </button>
                    </div>
                </div>
                
                <div class="mb-4">
                    <label for="activationCodeInput" class="form-label">{m.login_offline_activation_code_label()}</label>
                    <div class="input-group">
                        <input type="text" class="form-control" id="activationCodeInput" placeholder={m.login_offline_activation_code_placeholder()} bind:value={activationCode}>
                        <button type="button" class="btn btn-outline-light" onclick={PasteActivationCode}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M10 1.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1Zm-5 0A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5v1A1.5 1.5 0 0 1 9.5 4h-3A1.5 1.5 0 0 1 5 2.5v-1Zm-2 0h1v1H3a1 1 0 0 0-1 1V14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3.5a1 1 0 0 0-1-1h-1v-1h1a2 2 0 0 1 2 2V14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3.5a2 2 0 0 1 2-2Z"/>
                            </svg>
                            {m.login_offline_paste_button()}
                        </button>
                    </div>
                </div>
                
                <div class="d-grid gap-2 mb-4">
                    <button type="submit" class="btn btn-primary" disabled={!activationCode || loading}>
                        {#if loading}
                            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            {m.login_offline_activating_button()}
                        {:else}
                            {m.login_offline_activate_button()}
                        {/if}
                    </button>
                </div>
            </form>
            
            <div class="instructions-section">
                <h6 class="mb-3">{m.login_offline_instructions_title()}</h6>
                <ol>
                    <li>{m.login_offline_instruction_1()}</li>
                    <li>{@html m.login_offline_instruction_2()}</li>        
                    <li>{m.login_offline_instruction_3()}</li>           
                    <li>{@html m.login_offline_instruction_4()}</li>
                    <li>{m.login_offline_instruction_5()}</li>
                    <li>{m.login_offline_instruction_6()}</li>
                </ol>
            </div>
            
            <small class="form-text text-center text-white small">
                {m.login_offline_support_text()}
            </small>
        </div>
    </div>
</div>

<style lang="css">
#LoginScreen {
    position: relative;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    color: #f0f0f0;
    font-family: 'Roboto', sans-serif;
    background: #000000;
    background: linear-gradient(154deg, rgba(0, 0, 0, 1) 0%, rgba(6, 71, 57, 1) 100%);
}

.LoginPageWrapper {
    height: 100vh;
    position: relative;
    z-index: 1;
}

.LoginFormWrapper {
    background: rgba(0, 0, 0, 0.45);
    backdrop-filter: blur(10px);
    border-radius: 15px;
    padding: 40px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.1);
    max-height: 90vh;
    overflow-y: auto;
}

/* Offline Badge */
.offline-badge .badge {
    background: linear-gradient(135deg, #dc3545, #c82333);
    color: white;
    padding: 8px 20px;
    border-radius: 20px;
    font-size: 0.9rem;
    font-weight: 500;
    letter-spacing: 0.5px;
}

/* Form Styling */
.form-label {
    color: #f0f0f0;
    font-weight: 500;
    margin-bottom: 0.5rem;
}

.form-control {
    background-color: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: #f0f0f0;
    border-radius: 8px;
    padding: 12px 16px;
    transition: all 0.3s ease;
}

.form-control:focus {
    background-color: rgba(255, 255, 255, 0.15);
    border-color: #089264;
    box-shadow: 0 0 0 0.2rem rgba(8, 146, 100, 0.25);
    color: #f0f0f0;
}

.form-control::placeholder {
    color: rgba(240, 240, 240, 0.6);
}

.form-control:disabled {
    background-color: rgba(255, 255, 255, 0.05);
    color: rgba(240, 240, 240, 0.7);
    cursor: not-allowed;
}

/* Input Group */
.input-group .form-control {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.input-group .btn {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    display: flex;
    align-items: center;
    gap: 6px;
}

/* Button Styling */
.btn-primary {
    background: linear-gradient(135deg, #089264, #06734e);
    border: none;
    border-radius: 8px;
    padding: 12px 24px;
    font-weight: 500;
    transition: all 0.3s ease;
}

.btn-primary:hover:not(:disabled) {
    background: linear-gradient(135deg, #009978, #00853c);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(8, 146, 100, 0.3);
}

.btn-primary:disabled {
    background: rgba(8, 146, 100, 0.4);
    transform: none;
    box-shadow: none;
    cursor: not-allowed;
}

.btn-outline-light {
    border-color: rgba(255, 255, 255, 0.3);
    color: #f0f0f0;
    transition: all 0.3s ease;
}

.btn-outline-light:hover {
    background-color: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.5);
    color: #f0f0f0;
}

/* Alert Styling */
.alert {
    border-radius: 8px;
    border: none;
    padding: 12px 16px;
    margin-bottom: 1.5rem;
}

.alert-danger {
    background-color: rgba(220, 53, 69, 0.2);
    color: #ff6b6b;
    border-left: 4px solid #dc3545;
}

/* Instructions Section */
.instructions-section {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 20px;
    border: 1px solid rgba(255, 255, 255, 0.1);
}

.instructions-section h6 {
    color: #f0f0f0;
    font-weight: 500;
}

.instructions-section ol {
    color: rgba(240, 240, 240, 0.8);
    padding-left: 20px;
    margin-bottom: 0;
}

.instructions-section li {
    margin-bottom: 8px;
    line-height: 1.5;
}

/* Loading Spinner */
.spinner-border-sm {
    width: 1rem;
    height: 1rem;
}

small {
    display: block;
    margin-top: 15px;
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.7);
}

/* Responsive */
@media (max-width: 768px) {
    .LoginFormWrapper {
        padding: 30px 20px;
        margin: 10px;
    }
    
    .form-control {
        font-size: 16px;
    }
}

/* Custom scrollbar */
.LoginFormWrapper::-webkit-scrollbar {
    width: 6px;
}

.LoginFormWrapper::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
}

.LoginFormWrapper::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 3px;
}

.LoginFormWrapper::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.5);
}
</style>
    